import { combineReducers } from "redux";
import { connectRouter } from "connected-react-router";
import Settings from "./Settings";
import Auth from "./Auth";
import Common from "./Common";
import Accounts from "./Accounts";
import Users from "./Users";
import Offer from "./Offer";
import OfferPages from "./OfferPages";
import Avtal from "./Avtal";
import Order from "./Order";
import Event from "./Event";
import DashBoard from "./DashBoard";
import Intranet from "./Intranet";
import Aktivitet from "./Aktivitet";
import Eisgnering from "./Eisgnering";
import PdfEditor from "./PdfEditor"
import OffertPrev from "./OffertPrev"
import ArtikelReg from "./ArtikelReg"
import Importera from "./Importera"
import RingList from "./RingList"
import Ärende from "./Ärende"
import Projekt from "./Projekt"
import DocumentTempEditor from "./DocumentTempEditor"
import Mail from "./Mail"
import MailTempEditor from "./MailTempEditor"

export default (history) =>
  combineReducers({
    router: connectRouter(history),
    settings: Settings,
    auth: Auth,
    commonData: Common,
    accountsData: Accounts,
    userData: Users,
    offer: Offer,
    OfferPages: OfferPages,
    Avtal: Avtal,
    Order: Order,
    Event: Event,
    DashBoard: DashBoard,
    Intranet: Intranet,
    Aktivitet: Aktivitet,
    Eisgnering: Eisgnering,
    PdfEditor: PdfEditor,
    OffertPrev: OffertPrev,
    ArtikelReg: ArtikelReg,
    importera: Importera,
    RingList: RingList,
    Ärende: Ärende,
    Projekt: Projekt,
    DocumentTempEditor: DocumentTempEditor,
    Mail: Mail,
    MailTempEditor: MailTempEditor,
  });
